// import 'lib-flexible'

// rem.js
function setRem() {
    const docEl = document.documentElement
    const width = docEl.clientWidth

    if (width < 768) {
        // 移动端
        docEl.style.fontSize = width / 10 + 'px' // 375px 设计稿时：37.5
    } else {
        // PC端
        const baseSize = 16 // 与 postcss 的 rootValue 配套
        const scale = width / 1920
        docEl.style.fontSize = baseSize * scale + 'px'
    }
}

setRem()

window.addEventListener('resize', setRem)
window.addEventListener('pageshow', function (e) {
    if (e.persisted) setRem()
})
